// ----------------------------------------------------------------------
// <copyright file="Izenda.QueryStringUtil.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

// Based on query-string of react-router idea with enhances.

/**
 * Parse a query string into an object.
 * @param {string} str
 */
const parseQuery = (queryString: string) => {
  if (typeof queryString !== 'string') {
    return {};
  }
  queryString = queryString.trim().replace(/^(\?|#|&)/, '');
  if (!queryString) {
    return {};
  }
  return queryString.split('&').reduce((result, param) => {
    let parts = param.replace(/\+/g, ' ').split('=');
    // Firefox (pre 40) decodes `%3D` to `=`
    // https://github.com/sindresorhus/query-string/pull/37
    let key = parts.shift();
    let val = parts.length > 0 ? parts.join('=') : undefined;
    key = decodeURIComponent(key);
    // missing `=` should be `null`:
    // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
    val = val === undefined ? null : decodeURIComponent(val);
    if (!result.hasOwnProperty(key)) {
      result[key] = val;
    } else if (Array.isArray(result[key])) {
      result[key].push(val);
    } else {
      result[key] = [result[key], val];
    }
    return result;
  }, {});
};

/**
 * Merge query objects
 * @param {Array<string|Object>} queries
 */
const mergeQuery = (...queries: Array<any>) =>
  queries.reduce((result, query) => {
    let queryObj = query;
    if (typeof query === 'string') {
      queryObj = parseQuery(query);
    }
    return Object.assign(result, queryObj);
  }, {});

/**
 * Get value of a key in query
 * @param {string|Object} query
 * @param {string} key
 */
const getValueByKey = (query: any, key: string) => {
  let queryObj = query || {};
  if (typeof query === 'string') {
    queryObj = parseQuery(query);
  }
  return queryObj[key];
};

export default {
  mergeQuery,
  getValueByKey
};



// WEBPACK FOOTER //
// ./ui/share/utils/Izenda.QueryStringUtil.js